var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    transform: "rotate(180)",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9929 0.945423C13.2851 0.651899 13.76 0.650877 14.0535 0.943139C14.3204 1.20883 14.3455 1.62544 14.1282 1.91952L14.0558 2.0038L8.03181 8.0538C7.76533 8.32143 7.34721 8.34578 7.05314 8.12683L6.96891 8.05384L0.943915 2.00384C0.651629 1.71034 0.652612 1.23547 0.946111 0.943182C1.21293 0.677468 1.62964 0.654124 1.9228 0.872586L2.00677 0.945378L7.50064 6.46141L12.9929 0.945423Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsIcon);
export default __webpack_public_path__ + "static/media/collaps-icon.5440e9537aa78ba852626e9c681bcc3d.svg";
export { ForwardRef as ReactComponent };